"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useVariationContext = exports.VariationContextContainer = exports.VariationContext = void 0;
const react_1 = __importStar(require("react"));
exports.VariationContext = react_1.default.createContext({
    currentVariation: undefined,
    setCurrentVariation: () => { }
});
const VariationContextContainer = (props) => {
    const [currentVariation, setCurrentVariation] = (0, react_1.useState)(undefined);
    return (react_1.default.createElement(exports.VariationContext.Provider, { value: { currentVariation, setCurrentVariation } }, props.children));
};
exports.VariationContextContainer = VariationContextContainer;
const useVariationContext = () => (0, react_1.useContext)(exports.VariationContext);
exports.useVariationContext = useVariationContext;
__exportStar(require("./"), exports);
